import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../services/api';
import { projectKeys } from './useProjects';
import type { Immobile, CreateImmobileInput, UpdateImmobileInput } from '../types';

export const immobileKeys = {
  all: ['immobile'] as const,
  detail: (projectId: string) => [...immobileKeys.all, projectId] as const,
};

export function useImmobile(projectId: string) {
  return useQuery({
    queryKey: immobileKeys.detail(projectId),
    queryFn: () => api.get<Immobile | null>('/immobile', { projectId }),
    enabled: !!projectId,
  });
}

export function useSaveImmobile() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: CreateImmobileInput) =>
      api.post<Immobile>('/immobile', data),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: immobileKeys.detail(variables.projectId),
      });
      queryClient.invalidateQueries({
        queryKey: projectKeys.detail(variables.projectId),
      });
    },
  });
}

export function useUpdateImmobile() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (variables: { projectId: string; data: UpdateImmobileInput }) =>
      api.patch<Immobile>(`/immobile/${variables.projectId}`, variables.data),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: immobileKeys.detail(variables.projectId),
      });
      queryClient.invalidateQueries({
        queryKey: projectKeys.detail(variables.projectId),
      });
    },
  });
}
